<mat-card>
  <mat-card-header>
    <h1 mat-card-title>{{ 'Welcome_Note_tr' | translate }} 🎉</h1>
  </mat-card-header>
  <mat-card-content>
    <div data-testid="dropdown-lang-btn-text" class="justify-text">
      {{ 'getStarted_Note_tr' | translate }}
    </div>

    <form (keydown.enter)="$event.preventDefault()" [formGroup]="videoForm">
      <mat-form-field>
        <mat-label>{{ 'Name_tr' | translate }}</mat-label>
        <input autotrim formControlName="name" matInput />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Company_tr' | translate }}</mat-label>
        <input autotrim formControlName="company" matInput />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>{{ 'Email_tr' | translate }}</mat-label>
        <input autotrim formControlName="email" lowerCase matInput />
        <mat-error>{{ 'Required_field_tr' | translate }}</mat-error>
      </mat-form-field>
      <h3>{{ 'Why_Video_Call_tr' | translate }}</h3>
      <div class="justify-text">
        {{ 'Why_Video_Call_Desc_tr' | translate }}
      </div>

      <form-actions>
        <button type="button" [routerLink]="['/login']" mat-stroked-button>
          <mat-icon>arrow_back</mat-icon>
          {{ 'back_to_login_page_tr' | translate }}
        </button>
        <button type="button" (click)="schedulaCall()" [disabled]="videoForm.invalid" color="primary" mat-raised-button>
          <mat-icon>schedule</mat-icon>
          {{ 'pick_a_time_tr' | translate }}
        </button>
      </form-actions>
    </form>
  </mat-card-content>
</mat-card>
